import {
    apiRequest,
    organizationDetail,
    organizationUpdate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

class UpdateRepository {

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", organizationDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", organizationUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository